import { baseUrl, forgerockErrors } from "../../utilities/configurations";
import { usePolicyContext } from "../../Contexts/AddPolicyContext";
import ExpiredOtpModal from "../../Components/ExpiredOtpModal";
import { FRAuth, StepType } from "@forgerock/javascript-sdk";
import { KeyboardArrowLeft } from "@mui/icons-material";
import ErrorModal from "../../Components/ErrorModal";
import { useAuth } from "../../Contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import apiRequest from "../../utilities/request";
import OtpField from "../../Components/OtpField";
import Button from "../../Components/Button";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  server_error_message,
  server_error_title,
} from "../../utilities/values";

function AddPolicyOTP() {
  const {
    setShowExpiredOtpModal,
    personalMaxicareNumber,
    showExpiredOtpModal,
    setConfigRestarted,
    setAlertMessage,
    setDisplayAlert,
    setJourneyStep,
    employeeNumber,
    setCurrentStep,
    setAlertTitle,
    setIsLoading,
    selectedType,
    alertMessage,
    displayAlert,
    currentStep,
    journeyStep,
    companyCode,
    resetValues,
    handleBack,
    alertTitle,
    birthDate,
    isLoading,
    navigate,
    setOtp,
    otp,
  } = usePolicyContext();

  const [isResending, setIsResending] = useState(false);
  const [counter, setCounter] = useState(180);
  const { userData } = useAuth();

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => setCounter((prevCounter) => prevCounter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const formatTime = (seconds) =>
    dayjs().startOf("day").add(seconds, "seconds").format("mm:ss");

  const addPolicy = async () => {
    try {
      const response = await apiRequest(
        baseUrl + "/policy/add-policy",
        "POST",
        {
          cardNo: personalMaxicareNumber.replace(/\s/g, ""),
          corpCode: companyCode,
          birthDate: dayjs(birthDate).format("MM/DD/YYYY"),
          employeeId: employeeNumber,
          isIndividual: selectedType === "Personal",
        }
      );
      if (response.status) {
        setIsLoading(false);
        navigate(`/add-policy/card-number/review-details`, { replace: true });
      } else {
        setIsLoading(false);
        setDisplayAlert(true);
        setAlertTitle("Error");
        setAlertMessage("Failed to add policy");
      }
    } catch (error) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
    }
  };

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
    setAlertMessage("");
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let journey_obj = JSON.parse(JSON.stringify(journeyStep));
    journey_obj.callbacks[0].payload.input[0].value = otp;
    journey_obj.payload.callbacks[0].input[0].value = otp;
    try {
      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          if (nextStep.payload.callbacks[0].type === "PasswordCallback") {
            setAlertMessage("Oops! Incorrect OTP. Please try again");
          } else if (
            nextStep.payload.callbacks[0].type === "TextOutputCallback" &&
            nextStep.payload.callbacks[0].output[0].value === "OTP is Expired"
          ) {
            setShowExpiredOtpModal(true);
          }
          setJourneyStep(nextStep);
          setIsLoading(false);
          break;
        case StepType.LoginSuccess:
          setCurrentStep(5);
          setJourneyStep(nextStep);
          addPolicy();
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            setIsLoading(false);
            resetValues();
            setConfigRestarted(true);
            setCurrentStep(1);
            navigate(`/add-policy/card-number`, { replace: true });
          }
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      setCurrentStep(1);
      navigate(`/add-policy/card-number`, { replace: true });
      console.log(err);
    }
  };

  const resendOtp = async () => {
    try {
      let journey_obj = JSON.parse(JSON.stringify(journeyStep));
      journey_obj.callbacks[0].payload.input[0].value = "RESEND0";
      journey_obj.payload.callbacks[0].input[0].value = "RESEND0";

      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          setJourneyStep(nextStep);
          setCounter(180);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            resetValues();
            setConfigRestarted(true);
            setCurrentStep(1);
            navigate(`/add-policy/card-number`, { replace: true });
          }
          break;
      }
    } catch (err) {
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      setCurrentStep(1);
      navigate(`/add-policy/card-number`, { replace: true });
      console.log(err);
    }
  };

  function isVerifyDisabled() {
    return otp.length < 6 || isLoading;
  }

  function getVerifyClassname() {
    if (otp.length < 6 || isLoading) {
      return `text-[#A3A7AB] bg-[#F6F7F7]`;
    } else {
      return `text-white`;
    }
  }

  const handleClose = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    let journey_obj = JSON.parse(JSON.stringify(journeyStep));
    journey_obj.callbacks[1].payload.input[0].value = 0;
    journey_obj.payload.callbacks[1].input[0].value = 0;
    try {
      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          setJourneyStep(nextStep);
          setOtp("");
          setCounter(180);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            resetValues();
            setConfigRestarted(true);
            setCurrentStep(1);
            navigate(`/add-policy/card-number`, { replace: true });
          }
          break;
      }
    } catch (err) {
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      setCurrentStep(1);
      navigate(`/add-policy/card-number`, { replace: true });
      console.log(err);
    } finally {
      setIsResending(false);
      setShowExpiredOtpModal(false);
    }
  };

  const handleCancelResend = () => {
    setConfigRestarted(true);
    setShowExpiredOtpModal(false);
    navigate("/add-policy/choose-membership", { replace: true });
  };

  let content = (
    <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24">
      <div className="w-full grid grid-cols-1 divide-y">
        <div className="flex flex-row p-3">
          <KeyboardArrowLeft className="cursor-pointer" onClick={handleBack} />
          <div className="text-center text-md font-bold flex-grow">
            Add Policy
          </div>
        </div>

        <div className="p-3">
          <div className="text-xl font-semibold">
            Let's verify your mobile number
          </div>

          <div className="flex flex-row mt-1">
            <div className="text-[#60656D]">
              Verify your account by entering the one-time password sent to
              {/* */}
              <span className="text-[#1F2328] font-semibold ml-1">
                {`+63 ${userData[0]?.mobileNo
                  .substr(3, 6)
                  .replace(/./g, "*")} ${userData[0]?.mobileNo.substr(9)}`}
              </span>
            </div>
          </div>
          <div className="mt-3">
            <OtpField
              value={otp}
              onChange={handleOtpChange}
              onSubmit={handleSubmit}
              hasErrored={!displayAlert && alertMessage}
            />
            <span className="text-sm text-[#D32F2F]">
              {!displayAlert ? alertMessage : ""}
            </span>
          </div>
          <div className="flex flex-row mt-3">
            <div className="text-sm text-[#60656D]">
              Didn't get the password?{" "}
              <button
                disabled={counter > 0}
                className={`ml-1 ${
                  counter === 0 && "cursor-pointer text-[#0947AB]"
                }`}
                onClick={counter === 0 ? resendOtp : null}
                onKeyDown={(event) =>
                  counter === 0 ? handleKeyDown(event, () => resendOtp) : null
                }
                tabIndex={0}
              >
                {counter !== 0
                  ? `Resend (in ${formatTime(counter)})`
                  : "Resend OTP"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white flex-grow" />
      <div className="flex flex-col sm:items-end items-center w-full p-4">
        <Button
          disabled={isVerifyDisabled()}
          className={`w-full h-12 mt-2 ${getVerifyClassname()}`}
          onClick={handleSubmit}
        >
          {isLoading ? <CircularProgress size={"1rem"} /> : "Verify"}
        </Button>
      </div>
    </div>
  );

  if (currentStep === 5) {
    content = (
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-grow">
              Add Policy
            </div>
          </div>
          <div className="p-3">
            <div className="text-xl font-semibold">Policy is being added</div>
            <div className="flex flex-row mt-1">
              <div className="text-[#60656D]">
                Please wait while we add your policy to our database...
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      {content}
      <ExpiredOtpModal
        open={showExpiredOtpModal}
        isLoading={isResending}
        onResend={handleResend}
        onCancel={handleCancelResend}
      />
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleClose}
      />
    </div>
  );
}

export default AddPolicyOTP;
